import { ILookupItemModel, ITransactionFormData } from "./types";

export interface ITransactionModel extends ITransactionFormData {
  id: number;
}

export interface SubscriptionPlan {
  id: string;
  name: string;
  description: string;
  images: string[];
  prices: {
    id: string;
    unitAmount: number;
    currency: string;
    recurring?: {
      interval: string;
      interval_count: number;
    };
  }[];
  metadata?: {
    features: string;
  };
}

export enum OperationStatus {
  Pending = "Pending",
  Completed = "Completed",
  Failed = "Failed",
}

export interface ITransactionUploadSummary {
  isComplete: boolean;
  errors: string[];
  totalProcessed: number;
  totalInserted: number;
  totalDuplicates: number;
  totalUpdated: number;
  // PropMix stats - simplified
  propMixLookupsSuccess?: number;
  propMixLookupsFailed?: number;
  propMixEnabled?: boolean;
  batchId?: string;
  // Import failure statistics
  validationFailures?: number;
  geocodingFailures?: number;
}

export interface ITransactionUploadProgress {
  processedCount: number;
  duplicateCount: number;
  insertedCount: number;
}

export interface IFinancialCategoryDataSummaryModel {
  totalCount?: number;
  /** Sum of the values; the percentage categories (averages) divide it by totalCount */
  totalAmount?: number;
  yearId?: number | undefined;
  month?: number | undefined;
  quarter?: number | undefined;
  /** Calendar year of the transaction date (a Pipeline entry's Potential Closing Date year) */
  year?: number;
  /** Active entry from the Pipeline folder */
  isPipeline?: boolean;
  /** Under Contract deal */
  isUnderContract?: boolean;
}

export type DecodedToken = {
  roles?: string[];
  [key: string]: any;
};
